// extracted by mini-css-extract-plugin
export default {"row_cell":"MockRows_row_cell__2mIxv","gradient":"MockRows_gradient__NPT62"};